import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';
import { EventCentreDialogState } from '../event-centre-dialog.state';

import { ToggleSearch } from './toggle-search.action';

export function toggleSearchReducer(
    state: EventCentreDialogState,
    action: PayloadAction<ActionType.NOTI__EC__TOGGLE_SEARCH, ToggleSearch>,
): EventCentreDialogState {
    return {
        ...state,
        searchOpen: action.payload.open ?? !state.searchOpen,
    };
}
